module.exports = __webpack_public_path__ + "img/5.1eee6931.jpg";